let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5OJzq")).then(() => parcelRequire('emIYj'));